import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const ListOfCookie = (params?: any) =>
    request({
        url: ApiURL.Query.ListOfCookie,
        method: RequestType.GET,
        params: params


    });
const ListOfCookieType = (params?: any) =>
    request({
        url: ApiURL.Query.ListOfCookieType,
        method: RequestType.GET,
        params: params


    });
const ListOfGroupByTypeId = (params?: any) =>
    request({
        url: ApiURL.Query.ListOfGroupByTypeId,
        method: RequestType.GET,
        params: params


    });
    const CookieManagementQuery = {
        ListOfCookie,
        ListOfCookieType,
        ListOfGroupByTypeId
      };
      
      export default CookieManagementQuery;